import {
    Box,
    Button,
    Popover as MUIPopover,
    TextField,
    Typography
} from "@mui/material";
import { useMemo, useState } from "react";
import { DateRange } from "react-date-range";
import { useSearch } from "../../../hooks/seach/useSearch";
import pt from 'date-fns/locale/pt';
import { styles } from "./styles";
import { format } from 'date-fns'

const maxDate = new Date(); //Hoje
const minDate = new Date(2021, 0, 1);

function Popover({ handleConfirm, componentToShowPopover, handleClose }) {
    const { rangeOccurrences } = useSearch();

    //Range selecionado pelo usuário
    const [ranges, setRanges] = useState({
        startDate: new Date(rangeOccurrences.startDate),
        endDate: new Date(rangeOccurrences.endDate),
        key: 'selection'
    });

    return (
        <MUIPopover
            id='popover-select-date'
            open={Boolean(componentToShowPopover)}
            anchorEl={componentToShowPopover}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}>
            <DateRange
                locale={pt}
                editableDateInputs={true}
                onChange={item => setRanges(item.selection)}
                moveRangeOnFirstSelection={false}
                ranges={[ranges]}
                maxDate={maxDate}
                minDate={minDate}
                dateDisplayFormat="dd MMMM yyyy"
            />

            <Box style={{ padding: 10 }}>
                <Button variant="outlined" onClick={() => handleConfirm(ranges)}>OK</Button>
                <Button variant="outlined" style={{ marginLeft: 10, color: 'grey', borderColor: 'grey' }} onClick={handleClose}>Cancelar</Button>
            </Box>

        </MUIPopover>
    );
}

export function DateRangeInput() {
    const [componentToShowPopover, setComponentToShowPopover] = useState(null);
    const {
        rangeOccurrences, setRangeOccurrences
    } = useSearch();

    const handleConfirm = (ranges) => {
        handleClose();
        setRangeOccurrences (ranges);
    }

    const handleClick = (event) => {
        setComponentToShowPopover(event.currentTarget);
    };

    const handleClose = () => {
        setComponentToShowPopover(null);
    };

    const value = useMemo(() => {

        const startDate = new Date(rangeOccurrences.startDate || minDate);
        const endDate = new Date(rangeOccurrences.endDate || maxDate);
        
        return format(startDate, 'dd/MM/yyyy') + " até " + format(endDate, 'dd/MM/yyyy');
        
    }, [rangeOccurrences, minDate, maxDate]);

    return (
        <>
            <Typography style={styles.labelInput}>
                Período:
            </Typography>
            <TextField
                fullWidth
                variant='outlined'
                onClick={handleClick}
                value={value}
                style={{ textAlignLast: 'center', backgroundColor: 'white' }}
            />
            <Popover
                handleConfirm={handleConfirm}
                handleClose={handleClose}
                componentToShowPopover={componentToShowPopover}
            />
        </>
    );
}